import { API_SUBMISSION_SUCCESS, API_SUBMISSION_FAILURE, API_SUBMISSION_LOADING } from '../actions/constants';

const initialState = {
  isLoading: false,
  hasFailed: false,
  data: {},
  errorMessages: {}
};

export default function(state = initialState, action) {
  switch (action.type) {
    case API_SUBMISSION_LOADING:
      return { ...state, isLoading: action.isLoading };
    case API_SUBMISSION_SUCCESS:
      return { ...state, hasFailed: false };
    case API_SUBMISSION_FAILURE:
      return { ...state, hasFailed: action.hasFailed, errorMessages: action.data };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/error_messages_reducer.js